// menuFilter.js

/**
 * 根据用户角色过滤菜单
 * @param {Array} menus - 原始菜单数据
 * @param {Array} userRoles - 用户角色数组
 * @returns {Array} 过滤后的菜单
 */
const filterMenusByRole = (menus, userRoles) => {
  // 递归过滤菜单项
  const filterMenu = (menuItems, parentRoles = []) => {
    return menuItems.reduce((filtered, item) => {
      // 确定当前菜单项的角色（继承父菜单角色）
      const itemRoles = item.roles || parentRoles

      // 检查用户是否有权限访问该菜单
      const hasPermission = userRoles.some(role => itemRoles.includes(role))
      if (!hasPermission) return filtered

      // 深拷贝当前菜单项（避免修改原始数据）
      const newItem = { ...item }

      // 处理子菜单
      if (newItem.children && newItem.children.length > 0) {
        newItem.children = filterMenu(newItem.children, itemRoles)

        // 如果子菜单全部被过滤，且当前菜单没有独立URL，则移除该菜单
        if (newItem.children.length === 0 && !newItem.url) {
          return filtered
        }
      }

      // 移除roles属性（前端渲染不需要）
      delete newItem.roles

      filtered.push(newItem)
      return filtered
    }, [])
  }

  return filterMenu(menus)
}

export default filterMenusByRole
